
export const colors = {
  main: '#66cc33',
  white: '#ffffff'
}

export const userTypeCodes = {
  0: 'PM',
  1: 'AM',
  2: 'S',
  3: 'SC',
  4: 'FIN'
};

export const userType = {
  PM: { key: 'PRODUCT_MANAGER', label: 'Capo prodotto' },
  S: { key: 'SUPPLIER', label: 'Fornitore' },
  AM: { key: 'STORE_MANAGER', label: 'Capo settore' },
  SC: { key: 'SUPPLY_CHAIN', label: 'Supply chain' },
  FIN: { key: 'FINANCE', label: 'Finanza' }
}

export const agreementState = {
  0: { key: 'DRAFT', label: 'Bozza' },
  1: {
    key: 'OPEN_WAITING',
    label: 'Aperto, in attesa dell\'approvazione del fornitore'
  },
  2: { key: 'OPEN_APPROVED', label: 'Aperto, approvato dal fornitore' },
  3: {
    key: 'CLOSED_APPROVED_FORWARDED',
    label: 'Approvato dal capo prodotto e inviato ai negozi'
  },
  4: { key: 'CLOSED_REJECTED_SUPPLIER', label: 'Rifiutato dal fornitore' },
  5: {
    key: 'CLOSED_REJECTED_PRODUCT_OWNER',
    label: 'Rifiutato dal capo prodotto'
  },
  6: { key: 'EXPIRED', label: 'Scaduto' },
  7: {
    key: 'CLOSED_REJECTED_AREA_MANAGER',
    label: 'Rifiutato dal capo settore'
  },
  8: {
    key: 'CLOSED_APPROVED_AREA_MANAGER',
    label: 'Approvato dal capo settore e inviato al negozio'
  }
}

export const purposeState = {
  0: {
    key: 'OPEN_WAITING_AREA_MANAGER',
    label: 'Aperta, in attesa dell\'approvazione del capo settore'
  },
  1: {
    key: 'APPROVED_WAITING_SUPPLIER',
    label: 'Approvata dal capo settore in attesa dell\'approvazione del fornitore'
  },
  2: { key: 'APPROVED_WAITING_AREA_MANAGER', label: 'Approvata dal fornitore, in attesa dell\'approvazione del capo settore' },
  3: { key: 'FORWARDED_SUPPLY_CHAIN', label: 'Approvata dal capo settore ed inviata alla logistica' },
  4: {
    key: 'FORWARDED_SUPPLIER',
    label: 'Spedito al fornitore'
  },
  5: {
    key: 'RECEIVED_SUPPLIER',
    label: 'Ricevuto dal fornitore'
  },
  6: { key: 'CLOSED_REJECTED_SUPPLIER', label: 'Rifiutato dal fornitore' },
  7: {
    key: 'CLOSED_REJECTED_AREA_MANAGER',
    label: 'Rifiutata dal capo settore'
  },
  8: { key: 'EXPIRED', label: 'Scaduto' },
  9: {key: 'DRAFT', label: 'Bozza'},
  10: {key: 'OPEN_WAITING', label: 'Aperto, in attesa dell\'approvazione del fornitore'},
  11: {key: 'OPEN_APPROVED', label: 'Aperto, approvato dal fornitore'}
}

export const agreementType = {
  SAME_SUPPLIER: 'Stesso fornitore',
  DIFFERENT_SUPPLIER: 'Diverso fornitore'
}

export const agreementPurpose = {
  RETURN: 'Reso',
  SELL: 'Vendita'
}

export const agreementTransportCosts = {
  SUPPLIER: 'Fornitore',
  LEROY_MERLIN: 'Leroy Merlin'
}

export const agreementRedeliveryOrganization = {
  INSTORE_SUPPLIER_WITHDRAWL: 'Ritiro in negozio da fornitore',
  SEND_TO_SUPPLIER: 'Invio da negozio a fonitore',
  TRANSIT_FROM_STORAGE: 'Transito e raccolta da deposito'
}

export const handleAgreementSupplier = {
  ACCEPT: 'Accetta proposta',
  ACCEPT_TRASH: 'Accetta mancato ritiro reso',
  REFUSE: 'Rifiuta proposta'
}
export const handleAgreementPm = {
  ACCEPT: 'Accetta proposta',
  REFUSE: 'Rifiuta proposta'
}

export const handleProposalSupplier = {
  ACCEPT: 'Accetta proposta',
  ACCEPT_TRASH: 'Accetta mancato ritiro reso',
  REFUSE: 'Rifiuta proposta'
}
export const handleProposalGeneral = {
  ACCEPT: 'Accetta proposta',
  REFUSE: 'Rifiuta proposta'
}

export const agreementTableLocale = {
  emptyText: 'Nessun accordo trovato'
}

export const purposeTableLocale = {
  emptyText: 'Nessuna proposta trovata'
}


export const refsTableLocale = {
  emptyText: 'Nessuna referenza trovata'
}

export const formats = {
  number: '0,0.00',
  currency: '$0,0.00',
  int: '0,0',
  percentage: '0%'
};

export const supplyChainChangeReasons = {
  0: {
    code: 'DAMAGED_GOODS',
    label: 'Merce danneggiata'
  },
  1: {
    code: 'COUNT_ERROR',
    label: 'Errore conteggio'
  },
  2: {
    code: 'OTHER',
    label: 'Altro motivo'
  }
}

export const gamma = ['A', 'B', 'C', 'D', 'L', 'P', 'R', 'S']



// WEBPACK FOOTER //
// ./src/common/constants.js